module.exports = __webpack_public_path__ + "media/images/icon-post-rectangle-0cfc4fc24f827f7fb156dd5d24ec6488.png";